import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/use-auth";

export function useIsAdmin(): boolean {
  const { user } = useAuth();
  const { data } = useQuery<{ isAdmin: boolean }>({
    queryKey: ["/api/admin/is-admin"],
    enabled: !!user,
    staleTime: 60_000,
  });
  return data?.isAdmin ?? false;
}
